import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'scan-box',
  size: 24,
  node: [
    ['path', { d: 'M12 12v5.5', key: '1fezw7' }],
    ['path', { d: 'M17 3h2a2 2 0 012 2v2', key: 'sxhzt8' }],
    ['path', { d: 'M21 17v2a2 2 0 01-2 2h-2', key: 'b4b27w' }],
    ['path', { d: 'M3 7V5a2 2 0 012-2h2', key: '5quapj' }],
    ['path', { d: 'M7 21H5a2 2 0 01-2-2v-2', key: 'rx7q13' }],
    ['path', { d: 'M7.264 9.252 12 12l4.737-2.748', key: '176tmc' }],
    [
      'path',
      {
        d: 'M7.995 8.514A2 2 0 007 10.244v3.516a2 2 0 00.996 1.73l3 1.74a2 2 0 002.008 0l3-1.74A2 2 0 0017 13.76v-3.517a2 2 0 00-.995-1.73l-3-1.742a2 2 0 00-1.892-.064z',
        key: '7zy66p',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ScanBox
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJ2NS41IiAvPgogIDxwYXRoIGQ9Ik0xNyAzaDJhMiAyIDAgMDEyIDJ2MiIgLz4KICA8cGF0aCBkPSJNMjEgMTd2MmEyIDIgMCAwMS0yIDJoLTIiIC8+CiAgPHBhdGggZD0iTTMgN1Y1YTIgMiAwIDAxMi0yaDIiIC8+CiAgPHBhdGggZD0iTTcgMjFINWEyIDIgMCAwMS0yLTJ2LTIiIC8+CiAgPHBhdGggZD0iTTcuMjY0IDkuMjUyIDEyIDEybDQuNzM3LTIuNzQ4IiAvPgogIDxwYXRoIGQ9Ik03Ljk5NSA4LjUxNEEyIDIgMCAwMDcgMTAuMjQ0djMuNTE2YTIgMiAwIDAwLjk5NiAxLjczbDMgMS43NGEyIDIgMCAwMDIuMDA4IDBsMy0xLjc0QTIgMiAwIDAwMTcgMTMuNzZ2LTMuNTE3YTIgMiAwIDAwLS45OTUtMS43M2wtMy0xLjc0MmEyIDIgMCAwMC0xLjg5Mi0uMDY0eiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/scan-box
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScanBox = createLucideIcon(__iconData);

export default ScanBox;
